import { services } from '../../../mocks/services';

const serviceColors = [
  { bg: 'bg-amber-50', icon: 'text-amber-500', border: 'border-amber-100' },
  { bg: 'bg-slate-50', icon: 'text-slate-600', border: 'border-slate-100' },
  { bg: 'bg-sky-50', icon: 'text-sky-500', border: 'border-sky-100' },
  { bg: 'bg-blue-50', icon: 'text-blue-500', border: 'border-blue-100' },
  { bg: 'bg-emerald-50', icon: 'text-emerald-500', border: 'border-emerald-100' },
  { bg: 'bg-teal-50', icon: 'text-teal-500', border: 'border-teal-100' },
];

export default function ServicesIcons() {
  return (
    <section id="services" className="py-20 px-6 bg-[#F7F9FC]">
      <div className="max-w-screen-xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-[#0A2540] font-heading mb-3">
            What Do You Need Fixed Today?
          </h2>
          <p className="text-gray-500 text-base font-body max-w-xl mx-auto">
            Select your service and we&apos;ll dispatch a vetted local professional to your door.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((service, idx) => {
            const color = serviceColors[idx % serviceColors.length];
            return (
              <a
                key={service.id}
                href="#cta"
                className={`group flex items-start gap-4 bg-white border ${color.border} rounded-xl p-6 cursor-pointer hover:-translate-y-1 hover:border-[#FF6B00]/30 transition-all duration-200`}
              >
                <div className={`w-12 h-12 flex items-center justify-center flex-shrink-0 rounded-lg ${color.bg}`}>
                  <i className={`${service.icon} text-xl ${color.icon}`} />
                </div>
                <div>
                  <h3 className="font-bold text-[#0A2540] text-base font-heading leading-tight mb-1 group-hover:text-[#FF6B00] transition-colors">
                    {service.name}
                  </h3>
                  <p className="text-gray-500 text-sm font-body leading-snug">{service.shortDesc}</p>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
